import React from "react";
import { useTheme } from "../../contexts/ThemeContext";

const Button = ({
  icon,
  children,
  onClick,
  disabled = false,
  variant = "primary",
  size = "medium",
  fullWidth = false,
  loading = false,
  className = "",
  style = {},
  ...props
}) => {
  const { theme } = useTheme();

  const getVariantStyles = () => {
    switch (variant) {
      case "primary":
        return {
          backgroundColor: disabled ? theme.border : theme.primary,
          color: "#FFFFFF",
          border: "none",
        };
      case "secondary":
        return {
          backgroundColor: theme.secondary,
          color: theme.text,
          border: `1px solid ${theme.border}`,
        };
      case "danger":
        return {
          backgroundColor: disabled ? theme.border : theme.error,
          color: "#FFFFFF",
          border: "none",
        };
      case "ghost":
        return {
          backgroundColor: "transparent",
          color: theme.primary,
          border: `1px solid ${theme.primary}`,
        };
      default:
        return {
          backgroundColor: theme.surface,
          color: theme.text,
          border: `1px solid ${theme.border}`,
        };
    }
  };

  const getSizeStyles = () => {
    switch (size) {
      case "small":
        return {
          width: "30%",
          height: "5vh",
          fontSize: "15px",
        };
      case "medium":
        return {
          width: "35%",
          height: "6vh",
          fontSize: "15px",
        };
      case "large":
        return {
          width: "40%",
          height: "6vh",
          fontSize: "17px",
        };
      default:
        return {
          padding: "12px 24px",
          fontSize: "16px",
        };
    }
  };

  const styles = {
    ...getVariantStyles(),
    ...getSizeStyles(),
    borderRadius: "8px",
    fontWeight: "600",
    cursor: disabled || loading ? "not-allowed" : "pointer",
    opacity: disabled ? 0.6 : 1,
    // width: fullWidth ? "100%" : "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.2s ease",
    outline: "none",
    textDecoration: "none",
    ...style,
  };

  return (
    <button
      onClick={disabled || loading ? undefined : onClick}
      disabled={disabled || loading}
      style={styles}
      className={`button ${className}`}
      {...props}
    >
      {loading && (
        <div
          style={{
            width: "16px",
            height: "16px",
            border: "2px solid transparent",
            borderTop: "2px solid currentColor",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
      )}
      {icon && icon}
      {children}
    </button>
  );
};

export default Button;
